import { render } from "./LogoutOtherBrowserSessionsForm.vue?vue&type=template&id=14bbefec"
import script from "./LogoutOtherBrowserSessionsForm.vue?vue&type=script&lang=js"
export * from "./LogoutOtherBrowserSessionsForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/antoniokatarov/PhpstormProjects/MAR WHS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__